$(function () {
  // バリデーション
  $("#post-submit").on("click", function () {
    $("#form").validationEngine('attach', {
      promptPosition: "bottomLeft",
    });
    if (!$('#form').validationEngine('validate')) {} else {
      if (!confirm('入稿しますか？')) {
        return false;
      } else {
        $("#overlay, #overlayWindow").fadeIn();
        $('#form')[0].submit();
        return false;
      }
    }
    return false;
  })
  const flagid = ($('input[name="post[flag][]"]'))
  // ファイルの中身が変わった時に、
  // フラグ、ファイルサイズ、ホバーをチェックする。
  // 最後にフラグ変更
  $('input[type=file]').on('change', function () {
    _extension(this)
    _max_filesize(this)
    _file_check_hover(this);
    _post_flag(this);
  })
  // 初期ファイル中身チェック
  $('.fileCheck').each(function () {
    _extension(this);
    _max_filesize(this);
    _file_check_hover(this)
    _post_flag(this);
  })
  // フラグの変更
  // ファイルを選択したらフラグを付けるようにする。
  // フラグを付けることにより、何番目のテーブルにファイルが分かるようにする。
  function _post_flag(input_file) {
    let fileFlag = $(input_file).prop('files').length
    let num = $(input_file).data('id')
    if (fileFlag == 1) {
      $(flagid[num]).val('true');
    } else {
      $(flagid[num]).val('false');
    }
  }

  // 対応ファイルバリデーション
  function _extension(params) {
    // 許可ファイル形式種類
    let fileCheck = $(params).val().length;
    if (fileCheck == 0) {
      return true;
    }

    const reg = /png|jpeg|jpg|tif|gif|zip|psd/;
    let extension = $(params).prop('files')[0].name;
    extension = extension.toLowerCase();
    extension = extension.match(/[^.]+$/)[0];

    if (!reg.test(extension)) {
      alert('ご指定のファイル拡張子は対応しておりません。\nZIPに圧縮後、再度入稿して下さい。');
      $(params).val('');
      return false;
    } else {
      return true;
    }

  }
  // ファイルサイズ
  // ファイルのサイズが1GBを超えたらアラートを出す。
  function _max_filesize(input_file) {
    let total_filesize = 0
    $('.fileCheck').each(function () {
      let fileCheck = $(this).val().length;
      if (fileCheck != 0) {
        total_filesize += $(this).prop('files')[0].size
      }
    })
    let limitSize = 1024 * 1024 * 1024 * 1;
    if (total_filesize > limitSize) {
      alert('合計ファイルサイズは1GB以下でご用意ください。');
      $(input_file).val('');
      return false;
    } else {
      $('#span-filesize').text(
        _mb_filesize(total_filesize)
      );
      return true;
    }
  }
  // ファイルサイズをMB変換
  function _mb_filesize(num) {
    num = num / 1024 / 1024 * 100
    num = Math.ceil(num);
    num /= 100
    return num
  }
  // テーブルホバー
  // ファイル選択した場合にtrタグの背景色を変える。
  function _file_check_hover(fileCheck_chenge) {
    let parent = $(fileCheck_chenge).parent().parent()
    let fileCheck = $(fileCheck_chenge).val().length;
    if (fileCheck == 0) {
      parent.css({
        'background-color': '#f8f9fa'
      });
    } else {
      parent.css({
        'background-color': '#dee2e6'
      });
    }
  }
});
$(function () {
  // バリデーション
  $("#post-submit").on("click", function () {
    $("#form").validationEngine('attach', {
      promptPosition: "bottomLeft",
    });
    if (!$('#form').validationEngine('validate')) {} else {
      if (!confirm('入稿しますか？')) {
        return false;
      } else {
        $("#overlay, #overlayWindow").fadeIn();
        $('#form')[0].submit();
        return false;
      }
    }
    return false;
  })
  const flagid = ($('input[name="post[flag][]"]'))
  // ファイルの中身が変わった時に、
  // フラグ、ファイルサイズ、ホバーをチェックする。
  // 最後にフラグ変更
  $('input[type=file]').on('change', function () {
    _extension(this)
    _max_filesize(this)
    _file_check_hover(this);
    _post_flag(this);
  })
  // 初期ファイル中身チェック
  $('.fileCheck').each(function () {
    _extension(this);
    _max_filesize(this);
    _file_check_hover(this)
    _post_flag(this);
  })
  // フラグの変更
  // ファイルを選択したらフラグを付けるようにする。
  // フラグを付けることにより、何番目のテーブルにファイルが分かるようにする。
  function _post_flag(input_file) {
    let fileFlag = $(input_file).prop('files').length
    let num = $(input_file).data('id')
    if (fileFlag == 1) {
      $(flagid[num]).val('true');
    } else {
      $(flagid[num]).val('false');
    }
  }
  // 対応ファイルバリデーション

  function _extension(params) {
    // 許可ファイル形式種類
    let fileCheck = $(params).val().length;
    if (fileCheck == 0) {
      return true;
    }
    const reg = /png|jpeg|jpg|tif|gif|zip|psd/;
    let extension = $(params).prop('files')[0].name;
    extension = extension.toLowerCase();
    extension = extension.match(/[^.]+$/)[0];
    if (!reg.test(extension)) {
      alert('ご指定のファイル拡張子は対応しておりません。\nZIPに圧縮後、再度入稿して下さい。');
      $(params).val('');
      return false;
    } else {
      return true;
    }
  }
  // ファイルサイズ
  // ファイルのサイズが1GBを超えたらアラートを出す。
  function _max_filesize(input_file) {
    let total_filesize = 0
    $('.fileCheck').each(function () {
      let fileCheck = $(this).val().length;
      if (fileCheck != 0) {
        total_filesize += $(this).prop('files')[0].size
      }
    })
    let limitSize = 1024 * 1024 * 1024 * 1;
    if (total_filesize > limitSize) {
      alert('合計ファイルサイズは1GB以下でご用意ください。');
      $(input_file).val('');
      return false;
    } else {
      $('#span-filesize').text(
        _mb_filesize(total_filesize)
      );
      return true;
    }
  }
  // ファイルサイズをMB変換
  function _mb_filesize(num) {
    num = num / 1024 / 1024 * 100
    num = Math.ceil(num);
    num /= 100
    return num
  }
  // テーブルホバー
  // ファイル選択した場合にtrタグの背景色を変える。
  function _file_check_hover(fileCheck_chenge) {
    let parent = $(fileCheck_chenge).parent().parent()
    let fileCheck = $(fileCheck_chenge).val().length;
    if (fileCheck == 0) {
      parent.css({
        'background-color': '#f8f9fa'
      });
    } else {
      parent.css({
        'background-color': '#dee2e6'
      });
    }
  }
});